import React from "react";
import { Row, Col } from 'reactstrap';

import CheckListProcessForm from '../../../check_list/process/form';

import { create, update } from './axios';

const CorporateCheckListAgreementProcessForm = props => {
  const {
    checkListProcess,
    currentCustomer,
    currentUser,
    data
  } = props;

  return(
    <Row>
      <Col md={12}>
        <CheckListProcessForm
          checkListProcess={ checkListProcess }
          currentCustomer={ currentCustomer }
          currentUser={ currentUser }
          data={ data }
          configuration={{
            context: "corporate",
            defaultRequestParams: {},
          }}
          services={{
            createService: create,
            updateService: update,
          }}
          routes={{
            showPath: Routes.corporate_check_list_agreement_process_path,
            indexPath: Routes.corporate_check_list_agreement_processes_path()
          }}
        />
      </Col>
    </Row>
  )
}

export default CorporateCheckListAgreementProcessForm;
